/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import styles from './Content.module.scss';

/**
 * Applies content styling
 */
export default function Content({ children, className = null, ...childProps }) {
  const containerClassName = [
    styles.content,
    className,
  ].join(' ');
  return (
    <div className={containerClassName} {...childProps}>
      {children}
    </div>
  );
}

Content.styles = {
  body14: styles['content__body-14'],
  medium: styles.content__medium,
  center: styles.content__center,
  right: styles.content__right,
  left: styles.content__left,
};

Content.propTypes = {
  /**
   * What goes in the content
   */
  children: PropTypes.node.isRequired,
  /**
   * Additional CSS class names for custom styling.
   */
  className: PropTypes.string,
};
